// extracted by mini-css-extract-plugin
export default {"page_title":"SectionTitle_page_title__TKs0E"};